
















































import Vue from "vue";
import AdminService from "@/services/adminService";
import { AdminUser } from "@/models/admin-user";

export default Vue.extend({
  data() {
    return {
      username: "",
      email: "",
      given_name: "",
      admin: "0",
      adminUsers: [] as AdminUser[],
      creating: false,
      isLoaded: false
    };
  },
  methods: {
    async submit(e) {
      this.creating = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        try {
          const adminService = new AdminService(jwt);
          const formData = new FormData();
          formData.append("username", this.username.trim());
          formData.append("email", this.email.trim());
          formData.append("admin", this.admin.trim());
          formData.append("given_name", this.given_name.trim());
          const response = await adminService.createUsers(formData);
          if (response && response.status == 200) {
            if (response.data) {
              this.creating = false;
              alert("Create Successfully");
              await this.$router.push("/admin-users");
            }
          }
        } catch (error) {
          this.creating = false;
          alert(JSON.stringify(error.response.data));
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-users");
    }
  }
});
